import ModelsRoutes from './pages/Models/routes'
import ModelPageRoutes from './pages/ModelPage/routes'
import ProjectRoutes from './pages/Project/routes'
import TeamRoutes from './pages/Team/routes'

const DashboardRoutes = [
  {
    path: "/",
    meta: {
      requiresOnboard: true,
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "DashboardModule" */ "./components/DashboardLayout.vue"
      ),
    children: [
      ...ModelsRoutes,
      ...ModelPageRoutes,
      ...ProjectRoutes,
      ...TeamRoutes,
      {
        path: "/return/stripe/:projectId",
        name: "StripeReturn",
        component: () =>
          import(
            /* webpackChunkName: "StripeModule" */ "./pages/StripeReturn.vue"
          ),
      },
      {
        path: "/user/settings",
        name: "UserSettings",
        component: () =>
          import(
            /* webpackChunkName: "StripeModule" */ "./pages/UserSettings.vue"
          ),
      },
      {
        path: "/error/payment-method",
        name: "NeedsPaymentMethod",
        component: () =>
          import(
            /* webpackChunkName: "StripeModule" */ "./pages/NeedsPaymentMethod.vue"
          ),
      },
    ],
  },
];

export default DashboardRoutes;
